module.exports = __webpack_public_path__ + "static/media/location-pin.21144e1e.svg";